enum Pagination {
    PAGE_SIZE = 10
}

export default Pagination;